export enum FiContactInformationTypes {
    WorkPhoneNumber = 1,
    CellPhoneNumber = 2,
    HomePhoneNumber = 3,
    WorkEmailAddress = 4,
    PrivateEmailAddress = 5,
    OtherEmailAddress = 6,
    OtherPhoneNumber = 7,
    //ImportedEmailAddress = 101,
    //ImportedPhoneNumber = 102,
}
